import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../contexts/LanguageContext';
import toastService from '../../../../utils/toastService';
import LmsNewsPhoto from './LmsNewsPhoto';
import { PHOTO_ACCEPT, validatePhotoFile } from '../utils/newsUtils';

const frameStyle = { width: '100%', maxWidth: '22rem', aspectRatio: '16 / 9', borderRadius: '0.75rem', overflow: 'hidden', border: '1px dashed #D0D5DD' };

const NewsPhotoPicker = ({ news, value, onChange, disabled = false }) => {
    const { th } = useLanguage();
    const inputRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        if (!value?.file) {
            setPreviewUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(value.file);
        setPreviewUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [value?.file]);

    const hasExistingPhoto = !!(news?.id && news?.photoDocumentId) && !value?.removed;
    const hasPhoto = !!value?.file || hasExistingPhoto;

    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        if (!file) return;
        const errorKey = validatePhotoFile(file);
        if (errorKey) {
            toastService.warn(th(errorKey), th('common.warning'));
            return;
        }
        onChange({ file, removed: false });
    };

    const handleRemove = () => {
        onChange({ file: null, removed: !!(news?.id && news?.photoDocumentId) });
    };

    return (
        <div className="flex flex-column gap-2">
            <div style={frameStyle} className="flex align-items-center justify-content-center surface-50">
                {value?.file && previewUrl && <img src={previewUrl} alt="" className="w-full h-full" style={{ objectFit: 'cover' }} />}
                {!value?.file && hasExistingPhoto && <LmsNewsPhoto news={news} className="w-full h-full" />}
                {!hasPhoto && (
                    <div className="flex flex-column align-items-center gap-2 text-color-secondary">
                        <i className="pi pi-image" style={{ fontSize: '1.5rem' }} />
                        <span className="text-sm">{th('lmsNews.form.noPhoto')}</span>
                    </div>
                )}
            </div>

            <input ref={inputRef} type="file" accept={PHOTO_ACCEPT} className="hidden" onChange={handleFileSelect} />

            <div className="flex align-items-center gap-2 flex-wrap">
                <Button type="button" label={hasPhoto ? th('lmsNews.form.changePhoto') : th('lmsNews.form.selectPhoto')} icon="pi pi-upload" outlined size="small" className="w-auto" disabled={disabled} onClick={() => inputRef.current?.click()} />
                {hasPhoto && <Button type="button" label={th('lmsNews.form.removePhoto')} icon="pi pi-trash" severity="danger" text size="small" className="w-auto" disabled={disabled} onClick={handleRemove} />}
            </div>
            <small className="text-color-secondary">{th('lmsNews.form.photoHint')}</small>
        </div>
    );
};

export default NewsPhotoPicker;
